import {getNative, isNative} from "@/shared/helpers/webapp";

export const PosPrinter = {
	COLUMNS: 32,

	justifySpaceBetween: (left, right, doubleHeight = false) => {
		let lineLength = PosPrinter.COLUMNS;
		if (doubleHeight) { lineLength /= 2; }
		let halfLineLen = lineLength / 2;
		let maxLeftLen = halfLineLen;
		if (right.length < maxLeftLen) { maxLeftLen = lineLength - right.length - 3; }
		let maxRightLen = halfLineLen;
		if (left.length < maxRightLen) { maxRightLen = lineLength - left.length - 3; }
		if (left.length > maxLeftLen) { left = left.substring(0, maxLeftLen) + ".."; }
		if (right.length > maxRightLen) { right = right.substring(0, maxRightLen) + ".."; }
		let spaceBetweenStrings = lineLength - left.length - right.length;
		if (spaceBetweenStrings < 0) { spaceBetweenStrings = 0; }
		let stringToPrint = left + " ".repeat(spaceBetweenStrings) + right;
		return doubleHeight ? PosPrinter.doubleSize(stringToPrint)+"\n" : stringToPrint+"\n";
	},
	doubleSize: (text) => { return "\x1d\x21\x11" + text + "\x1d\x21\x00"; },
	bold: (text) => { return "\x1b\x45\x0f" + text + "\x1b\x45\x00"; },
	justifyCenter: (text) => { return "\x1b\x61\x01" + text + "\n\x1b\x61\x00"; },

	printPOSCloseOut: (businessName, dateStart, dateEnd, amount, txNumber, refundsNumber, cancelsNumber, totalFees) => {
		if(!isNative()) { return; }
		let today = new Date();
		let month = today.getMonth()+1;
		let day = (today.getDate() < 10 ? '0' : '') + today.getDate() + '/' + (month < 10 ? '0' : '') + month;
		let hours = (today.getHours() < 10 ? '0' : '') + today.getHours()+':'+(today.getMinutes() < 10 ? '0' : '') + today.getMinutes()
		let dateString = day+' '+hours

		let monthStart = dateStart.getMonth()+1;
		let dayStart = (dateStart.getDate() < 10 ? '0' : '') + dateStart.getDate() + '/' + (monthStart < 10 ? '0' : '') + monthStart;
		let hoursStart = (dateStart.getHours() < 10 ? '0' : '') + dateStart.getHours()+':'+(dateStart.getMinutes() < 10 ? '0' : '') + dateStart.getMinutes()
		let dateStartString = dayStart+' '+hoursStart

		let monthEnd = dateEnd.getMonth()+1;
		let dayEnd = (dateEnd.getDate() < 10 ? '0' : '') + dateEnd.getDate() + '/' + (monthEnd < 10 ? '0' : '') + monthEnd;
		let hoursEnd = (dateEnd.getHours() < 10 ? '0' : '') + dateEnd.getHours()+':'+(dateEnd.getMinutes() < 10 ? '0' : '') + dateEnd.getMinutes()
		let dateEndString = dayEnd+' '+hoursEnd

		let printOutput = "";
		printOutput += PosPrinter.justifySpaceBetween("Qromo POS", dateString);
		printOutput += PosPrinter.justifyCenter("Da "+dateStartString+" a "+dateEndString)+"\n";
		printOutput += PosPrinter.justifyCenter(PosPrinter.bold(businessName))+"\n";
		printOutput += PosPrinter.justifyCenter(PosPrinter.doubleSize((amount/100).toFixed(2)+" EUR"))+"\n";
		printOutput += PosPrinter.justifyCenter("Fees "+((totalFees/1.22)/100).toFixed(2)+" + IVA = "+((totalFees)/100).toFixed(2)+" EUR");
		printOutput += PosPrinter.justifyCenter(PosPrinter.bold("Netto "+((amount-totalFees)/100).toFixed(2)+" EUR"))+"\n";
		printOutput += PosPrinter.justifySpaceBetween(PosPrinter.bold("Transazioni"), "");
		printOutput += PosPrinter.justifySpaceBetween("Riuscite", txNumber.toString());
		printOutput += PosPrinter.justifySpaceBetween("Annullate", cancelsNumber.toString());
		printOutput += PosPrinter.justifySpaceBetween("Rimborsi", refundsNumber.toString());
		printOutput += "\n\n\n\n";

		getNative().print(printOutput);
	},
}